import Vue from 'vue'
import App from './App.vue'
import router from './router'
import foot from '@/components/footer.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from "axios";

Vue.use(ElementUI)

Vue.component('foot',foot)

Vue.prototype.$axios = axios

Vue.config.productionTip = false

//跳转后返回顶部
router.afterEach((to,from,next)=>{
    window.scrollTo(0,0)
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
